export default __webpack_public_path__ + "static/media/lastComunication.e8460539.svg";